/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PlanNumber/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PlanNumber({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/PlanNumber"
  
}) {
let assignedInsuranceInsuranceSubscriptionInsurancePlanNumberValueData = fromData.useDataValue({ viewPath,
context: 'assigned_insurance',
path: 'insurance_subscription.insurance_plan.number',
})
let constantData = '-'
let aggregateData = fromAggregate.any(assignedInsuranceInsuranceSubscriptionInsurancePlanNumberValueData, constantData)
  return (<React.Fragment
>
<div
  data-testid="PlanNumber.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="assigned_insurance.insurance_subscription.insurance_plan.number"
 data="'-'"
 aggregate="/Data/aggregate.js any"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}